var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('locationnodes',{attrs:{"locationnodes":_vm.locationNodes,"totalitems":_vm.locationNodesLength,"isloading":_vm.isLoading},on:{"locationNodeSaved":function($event){return _vm.initialize()},"locationNodeAdded":function($event){return _vm.setLocationLength()},"searchInitiated":function($event){return _vm.setLocationLength()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }